import { Icon } from 'util/ui'

export default function NavigatableIntegrationDetail({
  children,
  className,
  onBack,
  title,
}) {
  return (
    <div className={className}>
      <div className="NavigatableIntegrationWidgetCard-Detail-title">
        <Icon
          className="NavigatableIntegrationWidgetCard-Detail-icon chevron left"
          onClick={onBack}
        />
        {title}
      </div>
      {children}
    </div>
  )
}
